const VOLATILE_CACHE_PREFIXES = [
  "verdeo:",
  "verdeo:syntheses:",
  "verdeo:syntheses-impact:",
  "verdeo:syntheses-project-catalog:",
  "verdeo:syntheses-grouped-contracts:",
];

export function isQuotaExceededError(error: unknown) {
  return (
    typeof DOMException !== "undefined" &&
    error instanceof DOMException &&
    (error.name === "QuotaExceededError" ||
      error.name === "NS_ERROR_DOM_QUOTA_REACHED" ||
      error.code === 22 ||
      error.code === 1014)
  );
}

export function clearVolatileBrowserCaches(
  storage: Storage | null | undefined =
    typeof window !== "undefined" ? window.localStorage : null,
) {
  if (!storage) return;

  try {
    const keysToRemove: string[] = [];
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (
        key &&
        VOLATILE_CACHE_PREFIXES.some((prefix) => key.startsWith(prefix))
      ) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => storage.removeItem(key));
  } catch {
    // La purge du cache est best-effort: l'application ne doit pas crasher.
  }
}

export function clearAllVolatileBrowserCaches() {
  if (typeof window === "undefined") return;

  clearVolatileBrowserCaches(window.localStorage);
  clearVolatileBrowserCaches(window.sessionStorage);
}

export function safeSetLocalStorageItem(key: string, value: string) {
  if (typeof window === "undefined") return false;

  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (error) {
    if (!isQuotaExceededError(error)) return false;

    clearVolatileBrowserCaches(window.localStorage);
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch {
      return false;
    }
  }
}

export function safeGetLocalStorageItem(key: string) {
  if (typeof window === "undefined") return null;

  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}
